/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type KiteTrxTokenTransferInfo = {
    BNO: string;
    TRXHA: string;
    MTH: string;
    TKNTYPE: KiteTrxTokenTransferInfo.TKNTYPE;
    ACTTYPE: KiteTrxTokenTransferInfo.ACTTYPE;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    VAL: string;
    TKNCTR: EvmTokenSummaryInfo;
    TKNID: string;
    AG: string;
    UT: number;
};

export namespace KiteTrxTokenTransferInfo {

    export enum TKNTYPE {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }

    export enum ACTTYPE {
        MINT = 'MINT',
        BURN = 'BURN',
        TRANSFER = 'TRANSFER',
        MUTATE = 'MUTATE',
        BIDDING = 'BIDDING',
        CANCEL_BIDDING = 'CANCEL_BIDDING',
        COLLECTION_BIDDING = 'COLLECTION_BIDDING',
        COLLECTION_CANCEL_BIDDING = 'COLLECTION_CANCEL_BIDDING',
        LISTING = 'LISTING',
        DELIST = 'DELIST',
        SOLD = 'SOLD',
        UPDATE_PRICE = 'UPDATE_PRICE',
        CREATE_TOKEN = 'CREATE_TOKEN',
        CREATE_COLLECTION = 'CREATE_COLLECTION',
        WITHDRAW = 'WITHDRAW',
        DEPOSIT = 'DEPOSIT',
        OBJECT_CORE = 'OBJECT_CORE',
        DELETE_RESOURCE = 'DELETE_RESOURCE',
    }


}

